import React from "react";
import { Fab } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Whatsapp = () => {
  const phoneNumber = "918849149900"; // Replace with your WhatsApp number

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, "_blank");
  };

  return (
    <Fab
      color="success"
      aria-label="WhatsApp"
      onClick={handleClick}
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: 1000,
        bgcolor: "#25D366",
        "&:hover": { bgcolor: "#1DA851" }
      }}
    >
      <WhatsAppIcon sx={{ fontSize: 30, color: "#fff" }} />
    </Fab>
  );
};

export default Whatsapp;
